import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IzlogujUpozorenjeDialogComponent } from '../../../../core-ui/src/lib/ui/izloguj-upozorenje-dialog/izloguj-upozorenje-dialog.component';
import { Router } from '@angular/router';
import {
  LoginType,
  RefreshTokenRequest,
  TokensClient,
} from '@kodit/core/data-api';
import {
  DynamicDialogConfig,
  DynamicDialogService,
} from '@kodit/core/shared-ui';
import { AuthService } from './auth.service';
import { DialogSize } from '../../../../shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { stringIsNullOrEmpty } from '@kodit/core/shared';
import {
  REFRESH_TOKEN_REMAINING_TIME_IN_SECONDS,
  REFRESH_TOKEN_REMAINING_TIME_STRING,
} from 'libs/core/core-ui/src/lib/core-service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  /** Props */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);

  constructor(
    private _router: Router,
    //  private _authService: AuthService,
    private _client: TokensClient,
    private _dialogService: DynamicDialogService,
  ) {}

  /**
   * Vraca da li je isti user dva puta ulogovan (boolean) kao posledica promene ove promenljive otvara se IzlogujUpozorenjeDialog
   */
  showLogoutDialog$ = new BehaviorSubject<boolean>(false);

  set setShowLogoutDialog(value: boolean) {
    this.showLogoutDialog$.next(value);
  }

  get getShowLogoutDialog() {
    return this.showLogoutDialog$.asObservable();
  }

  // public async tryRefreshingTokens(): Promise<boolean> {
  //   const refreshToken = this._authService.getRefreshToken;
  //   const token = this._authService.getToken;
  //
  //   if (!token || !refreshToken) {
  //     return false;
  //   }
  //
  //   try {
  //     const { data } = await this._client
  //       .refresh(
  //         new RefreshTokenRequest({
  //           refreshToken,
  //           token,
  //           sessionId: this._authService.getSessionId,
  //           loginType: LoginType.WEB,
  //         }),
  //         this._authService.getCurrentTenant,
  //       )
  //       .toPromise();
  //
  //     if (stringIsNullOrEmpty(data.sessionId)) {
  //       this._openIzlogujUpozorenjeDialog();
  //       return false;
  //     }
  //
  //     this._authService.setTokens(
  //       data.token,
  //       data.refreshToken,
  //       data.sessionId,
  //     );
  //     return true;
  //   } catch {
  //     this._authService.logout();
  //     return false;
  //   }
  // }

  private _openIzlogujUpozorenjeDialog() {
    if (
      this._getRemainingTimeFromLocalStorage() <=
      REFRESH_TOKEN_REMAINING_TIME_IN_SECONDS
    ) {
      this.dialogConfig.header =
        'Vaš korisnički nalog je ulogovan na drugom računaru ili pretraživaču!';
      this.dialogConfig.closable = false;
      this.dialogConfig.closeOnEscape = false;
      this.dialogConfig.hideCancel = true;
      this.dialogConfig.customSubmitButton = { label: 'Odjavi se' } as any;
      this._dialogService.open(
        IzlogujUpozorenjeDialogComponent,
        this.dialogConfig,
      );
    }
  }

  private _getRemainingTimeFromLocalStorage(): number {
    return Number.parseInt(
      localStorage.getItem(REFRESH_TOKEN_REMAINING_TIME_STRING),
    );
  }
}
